import React, { useState } from 'react';
import { TLanguageIDs, IItemDishesForGetInfo } from 'types';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Text from 'components/Text/Text';
import LanguageBar from './LanguageBar/LanguageBar';
import style from './MenuTranslationFullInfo.module.scss';

interface IMenuTranslationFullInfo {
	dishForFullInfo: IItemDishesForGetInfo | null;
}

const MenuTranslationFullInfo: React.FC<IMenuTranslationFullInfo> = ({ dishForFullInfo }) => {
	const [selectedTranslationTab, setTranslationTab] = useState<Nullable<TLanguageIDs>>(null);
	const IDsSelectedLanguages = dishForFullInfo?.translations.map((language) => language.languageId) || [];
	const fetchedLanguages =
		dishForFullInfo?.translations.map((language) => ({
			id: language.languageId,
			name: language.name,
			description: language.description,
		})) || [];
	const languageName =
		dishForFullInfo?.customer?.languages.find((el) => el.id === selectedTranslationTab)?.name || null;

	return (
		<div className={style.container} data-test="MenuTranslationFullInfo">
			{fetchedLanguages.length ? (
				<>
					<LanguageBar
						IDsSelectedLanguages={IDsSelectedLanguages}
						selectedTranslationTab={selectedTranslationTab}
						setTranslationTab={setTranslationTab}
					/>
					<Text
						translationNameSpace="form"
						translationKey={languageName}
						theme="secondary"
						size="l"
						weight="bold"
					/>
					{fetchedLanguages.map(
						(el) =>
							el.id === selectedTranslationTab && (
								<React.Fragment key={el.id}>
									<FullInfoField label="nameLabel" value={el.name} />
									<FullInfoField
										label="descriptionLabel"
										value={el.description}
										withXSSSecurity={true}
									/>
								</React.Fragment>
							),
					)}
				</>
			) : (
				<Text
					translationNameSpace="form"
					translationKey="noSelectedLanguagesHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
			)}
		</div>
	);
};

export default React.memo(MenuTranslationFullInfo);
